import * as React from 'react';
import { History } from 'history';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { useStore } from '../../State';
import OrderForm from './OrderForm';
import OrderFormErrors from './OrderFormErrors';

const LOGIN = 'login';

const Container = styled.div`
  width: 20rem;
  margin: auto auto 3.33rem;
  padding: 0 1rem;
`;

type Props = {
  history: History;
  children: React.ReactNode;
};

const FormContainer = ({ history, children }: Props) => {
  const { order, errors } = useStore();
  return (
    <Container>
      {children}
      <OrderFormErrors error={errors.get(LOGIN)} />
      <OrderForm
        onSubmit={async data => {
          const isSuccess = await order.fetchOrder(
            LOGIN,
            data.emailAddress,
            data.referenceNumber
          );
          if (isSuccess) {
            history.push(`${order.getMerchantReference()}/order`);
          }
          return isSuccess;
        }}
      />
    </Container>
  );
};

export default observer(FormContainer);
